import MojitoCore from 'mojito/core';

const log = MojitoCore.logger.get('BonusServiceFactory');

const voidResponder = () => {
    log.warn('bonusService instance is missing.');
    return Promise.reject();
};

const NULL_SERVICE = {
    getCampaigns: voidResponder,
};

/**
 * Singleton object that receives bonus service config and spawn service instance.
 *
 * @class ServiceFactory
 * @name serviceFactory
 * @memberof Mojito.Services.Bonus
 */
class ServiceFactory {
    constructor() {
        this.service = NULL_SERVICE;
    }

    /**
     * Init factory.
     *
     * @function init
     * @param {Mojito.Services.Bonus.AbstractBonusService} service - Bonus service implementation.
     * @memberof Mojito.Services.Bonus.serviceFactory
     */
    init(service) {
        this.service = service;
    }

    /**
     * Service getter.
     *
     * @function getService
     * @returns {Mojito.Services.Bonus.AbstractBonusService} Bonus service instance.
     * @memberof Mojito.Services.bonus.serviceFactory
     */
    getService() {
        return this.service;
    }
}

export default new ServiceFactory();
